import { observer, use$ } from '@legendapp/state/react';
import { Box, Image, SimpleGrid } from '@mantine/core';
import { PATTERN_MAP } from '../../constants';
import { gameState$, uiState$ } from '../../state';
import { AutoBetTowersGridBrick } from './auto-bet/AutoBetTowersGridBrick';
import { ManualBetTowersGridBrick } from './manual-bet/ManualBetTowersGridBrick';
import { WinDisplay } from './WinDisplay';

export const TowersGrid = observer(() => {
  const pattern = gameState$.pattern.get();

  const { rows, cols } = PATTERN_MAP[pattern];

  const activeTab = use$(uiState$.activeTab);

  return (
    <Box
      mt={{
        base: 16,
        md: 32,
      }}
      pos="relative"
      style={{
        aspectRatio: '500 / 550',
        maxWidth: '100%',
      }}
      w={{ base: '100%', sm: '90%', md: '80%', lg: 500 }}
    >
      {/* Frame - using picture element for responsive images */}

      <Image
        bottom={0}
        data-test-id="towers-grid-frame"
        h="100%"
        left={0}
        pos="absolute"
        right={0}
        src="/game/frame.webp"
        style={{
          userSelect: 'none',
          objectFit: 'contain',
        }}
        top={0}
        w="100%"
      />

      {/* Grid container with responsive padding */}
      <Box h="100%" pb="8%" pos="relative" pt="12%" px="13.05%" w="100%">
        <SimpleGrid
          bg="dark.7"
          cols={cols}
          data-test-id="towers-grid"
          h="100%"
          p={{ base: '2.5%', sm: '2.3%', md: '2.4%', lg: '2.4%' }}
          pos="relative"
          spacing={{ base: 3, sm: 5, md: 7, lg: 8 }}
          style={{
            borderRadius: '2%',
          }}
          w="100%"
        >
          {/* Logo with responsive sizing */}
          <Image
            data-test-id="towers-grid-logo"
            h="18%"
            src="/game/logo.webp"
            style={{
              userSelect: 'none',
              width: 'auto',
              maxHeight: 110,
              minHeight: 60,
              left: '50%',
              transform: 'translate(-50%, -50%)',
              objectFit: 'contain',
              position: 'absolute',
              zIndex: 100,
            }}
            top="-8%"
          />
          {Array.from({ length: rows * cols }, (_, globalIndex) => {
            const originalRowIndex = Math.floor(globalIndex / cols);
            const rowIndex = rows - 1 - originalRowIndex; // Reverse the row order (bottom to top)
            const columnIndex = globalIndex % cols; // Index within the column

            return (
              <Brick
                activeTab={activeTab}
                column={columnIndex}
                key={globalIndex}
                row={rowIndex}
              />
            );
          })}
          <WinDisplay />
        </SimpleGrid>
      </Box>
    </Box>
  );
});

const Brick = ({
  row,
  column,
  activeTab,
}: {
  row: number;
  column: number;
  activeTab: 'manual' | 'auto';
}) => {
  if (activeTab === 'manual') {
    return <ManualBetTowersGridBrick column={column} row={row} />;
  }

  return <AutoBetTowersGridBrick column={column} row={row} />;
};
